import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "midTitle text-center mt-5 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_vat_fiscal_data = _resolveComponent("vat-fiscal-data")!
  const _component_person_fiscal_data = _resolveComponent("person-fiscal-data")!
  const _component_op_address = _resolveComponent("op-address")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Hai la partita iva?",
          text: "Hai la partita iva?"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_toggler, {
          modelValue: _ctx.localValue.fiscalData.hasVat,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.fiscalData.hasVat) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    (_ctx.localValue.fiscalData.hasVat)
      ? (_openBlock(), _createBlock(_component_vat_fiscal_data, {
          key: 0,
          modelValue: _ctx.localValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_person_fiscal_data, {
      modelValue: _ctx.localValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue) = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Indirizzo di fatturazione",
        text: "Indirizzo di fatturazione"
      })
    ]),
    _createVNode(_component_op_address, {
      type: "text",
      modelValue: _ctx.localValue.fiscalData.fiscalAddress,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.fiscalData.fiscalAddress) = $event))
    }, null, 8, ["modelValue"])
  ]))
}